import React, { createContext, useState } from 'react';

const NavProjectContext = createContext();

export default NavProjectContext;

export function NavProjectProvider({ children }) {
  const [stratTitle, setStratTitle] = useState(null);
  const [stratNumber, setStratNumber] = useState(null);
  const [policyTitle, setPolicyTitle] = useState(null);
  const [goalTitle, setGoalTitle] = useState(null);
  const [techTitle, setTechTitle] = useState(null);
  const [projTitle, setProjTitle] = useState(null);
  const [portfolioTitle, setPortfolioTitle] = useState(null);
  const [portfProjTitle, setPortfProjTitle] = useState(null);
  const [policyIsPortfolio,setPolicyIsPortfolio] = useState(null)
  const [indexType, setIndexType] = useState(null)
  const [indexName, setIndexName] = useState(null)

  return (
    <NavProjectContext.Provider
      value={{
        stratTitle,
          stratNumber,
        policyTitle,
        goalTitle,
        techTitle,
        projTitle,
          policyIsPortfolio,
        portfolioTitle,
        portfProjTitle,
        indexType,
        indexName,
        setStratTitle,
          setPolicyIsPortfolio,
          setStratNumber,
        setPolicyTitle,
        setGoalTitle,
        setTechTitle,
        setProjTitle,
        setPortfolioTitle,
        setPortfProjTitle,
        setIndexType,
        setIndexName,
      }}
    >
      { children }
    </NavProjectContext.Provider>
  );
}
